import axios from "axios";

function normalizeList(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.results)) return data.results;
  return [];
}

function authHeaders(token) {
  return {
    Authorization: `JWT ${token}`,
    "Acting-as": "dealer",
  };
}

export async function fetchPaymentNotificationNotes(notificationId, token) {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/dealer/investec-notifications/notes/`,
    {
      params: { notification_id: notificationId },
      headers: authHeaders(token),
    }
  );
  return normalizeList(response.data);
}

export async function createPaymentNotificationNote(notificationId, note, token) {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/dealer/investec-notifications/notes/`,
    {
      notification_id: notificationId,
      note,
    },
    {
      headers: {
        ...authHeaders(token),
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}
